import {
  SET_DELETE_ENTITY_OFFLINE_DATA_DIALOG_OPEN,
  SET_STORAGE_SPACE_DIALOG_OPEN,
} from '../actions/DialogStatesActions';

const initialState = {
  storageSpace: {
    open: false,
  },
  deleteEntity: {
    open: false,
    entityId: undefined,
  },
};

const dialogStatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STORAGE_SPACE_DIALOG_OPEN:
      return {
        ...state,
        storageSpace: {
          open: action.payload.flag,
        },
      };
    case SET_DELETE_ENTITY_OFFLINE_DATA_DIALOG_OPEN:
      return {
        ...state,
        deleteEntity: {
          open: action.payload.flag,
          entityId: action.payload.entityId,
        },
      };

    default:
      return state;
  }
};

export default dialogStatesReducer;
